import React, { useState, useReducer, useRef, useEffect, useImperativeHandle, forwardRef } from "react";
import CustomDropDown from "../CustomDropDown/CustomDropDown";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classes from './InviteUserForm.module.css';
import ToggleInput from "../UI/ToggleInput";
import Input from "../CustomDropDown/Input/Input";
import Button1 from "../UI/Button/Button1";
import { createAppUser, inviteUser, provisionUser, UserPowerSearch } from "../../Api Methods/Api";
import { ListBox } from "primereact/listbox";
import { Button } from "primereact/button";
import { DataView } from "primereact/dataview";
import { classNames } from "primereact/utils";
import { Tag } from "primereact/tag";
import Button2 from "../UI/Button/Button2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import Papa from 'papaparse';
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { ToggleButton } from "primereact/togglebutton";
import { SelectButton } from "primereact/selectbutton";
import Modal from '../Modal/Modal'
import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import { Dialog } from "@mui/material";
import downloadIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/download.png'
import { Divider } from "primereact/divider";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const emailReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: emailRegex.test(action.val) };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}

// Reducer function
const userRoleReducer = (state, action) => {

    if (action.type === 'TOGGLE_DROPDOWN') {
        return { ...state, showDropDownOptions: !state.showDropDownOptions, isValid: null };
    }

    if (action.type === 'SELECT_OPTION') {
        return { ...state, selectedOption: action.payload, showDropDownOptions: false, isValid: action.val != "UserRole" };
    }

    if (action.type === 'BLUR_DROPDOWN') {
        return { ...state, showDropDownOptions: false, isValid: action.val != "UserRole" };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { selectedOption: null, isValid: null };
    }
    //otherwise 
    return { state };
};


const MassCreateUserForm = ({setSuccess, setFail, setLoading, countProcessed, setCountProcessed, setTotalCount, apiData, successMessage, setSuccessMessage }, props) => {

    const [formIsValid, setFormIsValid] = useState(false);
    const [emailState, dispatchEmail] = useReducer(emailReducer, {
        value: '',
        isValid: null
    });

    // UserRole Drop Down reducer  ----------------
    const [userRoleState, dispatchUserRole] = useReducer(userRoleReducer, {
        showDropDownOptions: false,
        selectedOption: '', // Initial selectedOption state
        isValid: null
    });

    const { showDropDownOptions: showUserRoleDropDownOptions, selectedOption: selectedUserRoleOption } = userRoleState;

    const [usersToCreate, setUsersToCreate] = useState([])
    const [role, setRole] = useState("Manager")
    const emailInputRef = useRef();
    const userRoleDropdownRef = useRef();
    const { isValid: emailIsValid } = emailState;
    const { isValid: userRoleIsValid } = userRoleState;
    const [userSuggestions, setUserSuggestions] = useState([]);
    const [stopSearch, setStopSearch] = useState(false)
    const [rowClick, setRowClick] = useState(true);
    const [isUsersToAddOpen, setIsUsersToAddOpen] = useState(false)
    const ModalDialog = useRef();
    const [modalTitle, setModalTitle] = useState("Create accounts")
    const [modalComponent, setModalComponent] = useState()
    const [rerender, setRerender] = useState(false)
    const [hasFile, setHasFile] = useState(false)


    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    }

    const emailChangeHandler = (event) => {
        dispatchEmail({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }

    const validateEmailHandler = () => {
        dispatchEmail({ type: 'INPUT_BLUR' });
    }

    // Drop down handlers ---------------
    const handleUserRoleDropDownOnClick = () => {
        dispatchUserRole({ type: 'TOGGLE_DROPDOWN' });
    };

    const handleUserRoleOptionChange = (option) => {
        dispatchUserRole({ type: 'SELECT_OPTION', payload: option });
    };
    const handleUserRoleBlur = () => {
        dispatchUserRole({ type: 'BLUR_DROPDOWN' });
    };

    const onClearHandler = () => {
        dispatchEmail({ type: 'INPUT_CLEAR', val: "" })
        dispatchUserRole({ type: 'INPUT_CLEAR', val: "" })
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    const company = useSelector(state => state.auth.companyName)
    const userID = useSelector(state => state.auth.userID);
    let processed = 0

    const processUserCreation = async () => {
        setLoading(true)
        console.log("called")
        console.log(usersToCreate)
        setTotalCount(usersToCreate.length)
        for (const user of usersToCreate) {
            console.log(user)

            const userBody = {
                email: user.email,
                name: `${user.firstName} ${user.surname}`,
                appName: company,
                verified: "yes",
                phoneNumber: user.phone,
                createdBy: userID
            };

            console.log(userBody)

            try {
                const response = await provisionUser(apiData, userBody, dispatch)
                processed++
                
                if (!response.success) {
                    console.error(`Failed for ${user.email}`);
                } else {
                    console.log(`Created user: ${user.email}`);
                    setCountProcessed(processed)
                    setSuccessMessage(`Successfully created ${user.email}`)
                }
            } catch (err) {
                console.error(`Error for ${user.email}`, err);
            }

            await delay(900);
        }

        setSuccess(true)
    };

    const createAccounts = () => {

    }

    const handleFileUpload = (e) => {
        const requiredColumns = ["First name", "Last name", "Email", "Phone number"];
        let file = e.target.files[0];
        if (!file) return;

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
               
                const headers = results.meta.fields;
                console.log(headers)
                const missingColumns = requiredColumns.filter(col => !headers.includes(col.trim()));
                console.log(headers)
                console.log(missingColumns)

                if (missingColumns.length > 0) {
                    file = null
                    e = null
                    alert(`The uploaded file is missing the following required columns: ${missingColumns.join(", ")}`);
                    return;
                }

                const users = results.data
                    // filter out rows where every value is empty
                    .filter(row => Object.values(row).some(val => val && val.trim() !== ""))
                    
                    .map(row => ({
                        firstName: row["First name"]?.trim() || "",
                        surname: row["Last name"]?.trim() || "",
                        email: row["Email"]?.trim() || "",
                        phone: row["Phone number"]?.trim() || "",
                    }));

                setUsersToCreate(prev => [...prev, ...users]);
                 setHasFile(true)
                //processUserCreation(users);
                console.log(users)
            }
        });    
    };

    const submitHandler = (event) => {
        event.preventDefault();
        processUserCreation();
    };

    return (
        <>
            <Modal ref={ModalDialog} title={modalTitle} modalName={"UsersToAdd"} HandleShowModal={HandleShowModal}>
                {modalComponent}
            </Modal>

            <form className={classes["container"]} onSubmit={submitHandler} method="dialog" >
                <p style={{ fontWeight: "600", fontSize: "18px", color: "#6e6e6e", margin: "4px 0" }}>
                    Upload a .csv file of user details</p>
                <br></br>

                 <div style={{display:"flex", flexDirection:"row"}}>
                    <img src={downloadIcon} style={{width:"20px", height:"20px", marginRight:"10px"}}/>
                    <p style={{ fontWeight: "500", fontSize: "16px", color: "#6e6e6e", margin: "4px 0" }}>
                        Please use the{" "}
                            <a
                                href="/Create_users_template.csv"
                                download
                                style={{ color: "#007bff", textDecoration: "underline" }}
                            >
                                provided template
                            </a>{" "}
                        to ensure accounts are created correctly
                    </p>
                </div>
                <Divider type="solid"/>
                
                <div>
                    <input type="file" accept=".csv" onChange={handleFileUpload} />
                </div>
                <Divider type="solid"/>
                
                <div style={{display:"flex", flexDirection: "row", alignSelf:"end" }}>
                    <Button severity="success" type="submit" label="Create accounts" disabled={!hasFile}/>
                </div>
                
            </form>
        </>
    )
}

export default MassCreateUserForm;

